
import { useNavigate } from "react-router-dom";
import { getApiUrl } from "../../data/api/apiManager";
import { ArtistResponseDTOMin } from "../../openapi-generated-client";
import { useSafeNavigate } from "../unloadBlocker";
import UserVerifiedIcon from "../userVerifiedIcon";
import "./artistDisplay.css";

interface ArtistDisplayProps {
    artist: ArtistResponseDTOMin;
    url: string;
    small?: boolean;
    advanced?: boolean;
    onClick?: () => void;
}

export default function ArtistDisplay(props: ArtistDisplayProps) {

    const navigate = useSafeNavigate(useNavigate());

    return <div className={"artist" + (props.small ? " small" : "")} onClick={() => {
        if(props.onClick) {
            props.onClick();
            return;
        }
        navigate(props.url + "/" + props.artist.id);
    }}>
        <img className="profile-picture" src={getApiUrl("assets/by-hash/" + props.artist.profilePicture)}/>
        <h2 className="fw-300">{props.artist.name}</h2>
        <UserVerifiedIcon artist={props.artist}/>
    </div>

}